import { initOnboardingStepOne } from '@organisms/organization/onboarding-step-one';
import { initOnboardingStepTwo } from '@organisms/organization/onboarding-step-two';

export default function () {
  initOnboardingStepOne();
  initOnboardingStepTwo();
}
